import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card } from "antd";
import QueryString from "qs";
import Loading from "../../../components/Loading/Loading";
import BasicHeaderLayout from "../../../layouts/BasicHeaderLayout/BasicHeaderLayout";
import { WebAuth } from "auth0-js";
import { AppManager } from "../../../manager";
import SimpleCenteredLayout from "../../../layouts/SimpleCentered/SimpleCenteredLayout";
import BasicErrorView from "../../../components/ErrorView/BasicErrorView/BasicErrorView";

const CheckAuth = () => {
    const location = useLocation();
    const [loadError, setLoadError] = useState<string>();
    useEffect(() => {
        let active = true;
        const rejectLogin = () => {
            if (active) AppManager.route.gotoLogin();
        };
        const callbackHash = window.location.hash;
        const hashParams = new URLSearchParams(callbackHash.replace(/^#\/?/, ""));
        if (hashParams.has("id_token") || hashParams.has("access_token")) {
            AppManager.auth.fetchAuthInfo((configurationError, info) => {
                if (!active) return;
                if (configurationError || !info?.authDomain || !info.authID) {
                    rejectLogin();
                    return;
                }
                try {
                    const authentication = new WebAuth({
                        domain: info.authDomain,
                        clientID: info.authID,
                        responseType: "token id_token",
                        redirectUri: `${window.origin}/#/auth/login`,
                        scope: "openid profile email",
                        leeway: 60,
                    });
                    // State and nonce must come from Lock's stored transaction, never the callback itself.
                    authentication.parseHash({ hash: callbackHash }, (error, result) => {
                        if (!active) return;
                        const token = result?.idToken;
                        const nonce = result?.idTokenPayload?.nonce;
                        if (error || typeof token !== "string" || !token || typeof nonce !== "string" || !nonce) {
                            rejectLogin();
                            return;
                        }
                        AppManager.auth.loginUserFromAuth0(
                            token,
                            nonce,
                            (err) => {
                                if (!active) return;
                                if (err) rejectLogin();
                                else AppManager.route.gotoOrgAuthorization();
                            },
                            () => active,
                        );
                    });
                } catch {
                    rejectLogin();
                }
            });
        } else if (hashParams.has("error")) {
            setLoadError("Sign-in could not be completed. Please try again.");
        } else {
            const querystring = QueryString.parse(location.search.substring(1));
            if (querystring.purge) {
                AppManager.auth.dispatchLogout();
            }
            AppManager.route.gotoLogin();
        }
        return () => {
            active = false;
        };
    }, [location.pathname, location.search, location.hash]);
    return loadError ? (
        <SimpleCenteredLayout
            children={
                <div style={{ padding: 50 }}>
                    <Card>
                        <BasicErrorView
                            error={loadError}
                            description={`
                Something went wrong while trying to authenticate you. One possible cause of this is that third party cookies are disabled on your browser as we heavily 
                depend on them to securely authenticate you. If you're sure that this is not the issue, please contact technical support with a snapshot of this entire page and we'll be happy to help.
            `}
                        />
                    </Card>
                </div>
            }
        />
    ) : (
        <BasicHeaderLayout title="" content={<Loading text="Authenticating..." />} />
    );
};

export default CheckAuth;
